/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  StopBotOptions,
  StopBotStatus200,
  StopBotStatus404,
  StopBotStatus500,
} from '../types/StopBot'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { stopBot } from '../clients/stopBot'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const stopBotMutationKey = () => [{ url: '/v1/bots/:bot_id/stop' }] as const

export function stopBotMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = stopBotMutationKey()
  return mutationOptions<
    StopBotStatus200,
    ResponseErrorConfig<StopBotStatus404 | StopBotStatus500>,
    StopBotOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return stopBot({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Stop a bot
 * {@link /v1/bots/:bot_id/stop}
 */
export function useStopBot<TContext>(
  options: {
    mutation?: UseMutationOptions<
      StopBotStatus200,
      ResponseErrorConfig<StopBotStatus404 | StopBotStatus500>,
      StopBotOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? stopBotMutationKey()

  const baseOptions = stopBotMutationOptions(config) as UseMutationOptions<
    StopBotStatus200,
    ResponseErrorConfig<StopBotStatus404 | StopBotStatus500>,
    StopBotOptions,
    TContext
  >

  return useMutation<
    StopBotStatus200,
    ResponseErrorConfig<StopBotStatus404 | StopBotStatus500>,
    StopBotOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    StopBotStatus200,
    ResponseErrorConfig<StopBotStatus404 | StopBotStatus500>,
    StopBotOptions,
    TContext
  >
}
